import { IQService, IPromise, IDeferred } from "angular";

import { IUser } from "@gtmhub/users/models";
import { IAssigneeIdMap } from "@gtmhub/assignees/models";
import { ISessionsIdMap } from "@gtmhub/sessions/models/models";
import { IGridSortingRule, IGridFilter } from "@gtmhub/shared/components/grid-filtering-bar";
import { AlignmentViewModes } from "./states/alignment-sidebar-ctrl";

export type AlignmentTreeViewMode = "compact" | "medium" | "relaxed" | "nested";

export type ItemsTreeOrderField = "title" | "sortedOwner.name" | "attainment.value" | "designScore.totalPoints";
export type GoalsTreeOrderField = "name" | "assignee.name" | "attainment" | "designScore.totalPoints";
export interface AlignmentContentState {
  hasItems: boolean;
  noFiltersOrHostSessionOnly: boolean;
}

export interface IAlignmentLoadedEventArgs {
  currentUser: IUser;
  assigneesIdMap: IAssigneeIdMap;
  sessionIdMap: ISessionsIdMap;
  currentSessionId: string;
  sharedId?: string;
  sharedParentId?: string;
  locateId?: string;
  viewModes: AlignmentViewModes;
  enabledDrag: boolean;
  order: IGridSortingRule[];
  filters: IGridFilter[];
  contentState: AlignmentContentState;
}

export class AlignmentLoader {
  private deferred: IDeferred<IAlignmentLoadedEventArgs>;
  private isLoaderPromiseResolved = false;

  public static $inject = ["$q"];

  constructor(private $q: IQService) {}

  init(): void {
    this.deferred = this.$q.defer<IAlignmentLoadedEventArgs>();
    this.isLoaderPromiseResolved = false;
  }

  promise(): IPromise<IAlignmentLoadedEventArgs> {
    return this.deferred.promise;
  }

  resolve(args: IAlignmentLoadedEventArgs): void {
    this.deferred.resolve(args);
    this.isLoaderPromiseResolved = true;
  }

  get isResolved(): boolean {
    return this.isLoaderPromiseResolved;
  }
}
